import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyEsRedirect } from "@/lib/i18n/routes";

// Spanish URLs without a published Spanish page permanently redirect to the
// matching English page, so old links, crawls and bookmarks never hit a 404.
export const Route = createFileRoute("/es/$")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: legacyEsRedirect(location.pathname), statusCode: 301 });
  },
});
